// ami+win@customer.io -> ami@customer.io
// ami++win@customer.io -> ami@customer.io
// ami+win+win2@customer.io -> ami@customer.io
//
// used for Google auth pop-up login hint for Google SSO/Google One-Click logins
export default function removeGoogleEmailAlias(fullEmail: string) {
  let [address, domain] = fullEmail.split('@');

  if (address.includes('+')) {
    address = address.split('+')[0];
  }

  return [address, domain].join('@');
}
